<opac-dialog [open]="open()" [title]="'report.title' | translate" (closed)="closeDialog()">
  <p>{{ 'report.description' | translate }}</p>

  <form id="report-form" [formGroup]="reportForm" (submit)="onSubmit($event)">
    <div class="checkboxes">
      <ng-container formArrayName="checkboxes">
        <opac-checkbox
          *ngFor="let checkbox of checkboxes.controls; let index = index"
          [formControlName]="index"
          [invalid]="checkbox | invalidControl"
          >{{ labels[index] | translate }}
        </opac-checkbox>

        <span *ngIf="checkboxes | invalidControl" class="error">
          {{ 'forms.error.selectYourOption' | translate }}
        </span>
      </ng-container>
    </div>

    <opac-textarea
      #descriptionTextarea
      formControlName="details"
      [counter]="true"
      [maxLength]="descriptionMaxLength()"
      [invalid]="details | invalidControl">
      {{ 'report.details' | translate }}

      <span *ngIf="details | invalidControl" slot="error">
        <span *ngIf="details.errors.maxlength"> {{ 'textarea.charCountExceeded' | translate }} </span>
        <span *ngIf="details.errors.required"> {{ 'signup.errors.required' | translate }} </span>
      </span>
    </opac-textarea>
  </form>

  <div slot="actions" class="actions">
    <opac-button actionType="submit" form="report-form"> {{ 'common.submit' | translate }} </opac-button>
    <opac-button type="tertiary" (click)="closeDialog()"> {{ 'common.cancel' | translate }} </opac-button>
  </div>
</opac-dialog>
